const SESSION_KEY = 'see_admin_session';

function safeParse(raw) {
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}

export function getAuthSession() {
  const session = safeParse(localStorage.getItem(SESSION_KEY));
  if (!session || typeof session !== 'object') {
    return {
      token: '',
      user: {
        account_id: 0,
        username: '',
        is_admin: false
      }
    };
  }
  return {
    token: session.token || '',
    expires_in: Number(session.expires_in || 0),
    user: {
      account_id: Number(session.user && session.user.account_id ? session.user.account_id : 0),
      username: session.user && session.user.username ? session.user.username : '',
      is_admin: !!(session.user && session.user.is_admin)
    }
  };
}

export function getToken() {
  return getAuthSession().token || '';
}

export function setAuthSession(payload) {
  const nextSession = {
    token: payload && payload.token ? payload.token : '',
    expires_in: payload && payload.expires_in ? payload.expires_in : 0,
    user: {
      account_id: payload && payload.user && payload.user.account_id ? payload.user.account_id : 0,
      username: payload && payload.user && payload.user.username ? payload.user.username : '',
      is_admin: !!(payload && payload.user && payload.user.is_admin)
    }
  };
  localStorage.setItem(SESSION_KEY, JSON.stringify(nextSession));
}

export function clearToken() {
  localStorage.removeItem(SESSION_KEY);
}

export function hasToken() {
  return !!getToken();
}

export function getCurrentUser() {
  return getAuthSession().user;
}

export function isAdmin() {
  return !!getCurrentUser().is_admin;
}
